import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink, PenLine } from 'lucide-react';
import { useSeo } from '../lib/seo';
import { CriteriaAccordion } from './TradeSubPages';

// Public (no partner login) criteria browser so businesses can read every
// category's rules before registering on the external VisitEngland portal.
export default function AwardsCriteriaPage() {
  useSeo(
    'Tourism Awards Category Criteria — Leicestershire Tourism & Hospitality Awards | GoLeicestershire',
    "Read the eligibility criteria and judging process for every Leicestershire Tourism & Hospitality Awards category before you enter — no account needed."
  );
  return (
    <div data-testid="awards-criteria-page">
      <section className="bg-charcoal text-base py-16 md:py-20">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <div className="label text-mustard mb-3">Leicestershire Tourism &amp; Hospitality Awards</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-5">Pick your category with confidence.</h1>
          <p className="text-base/80 max-w-2xl leading-relaxed mb-8">
            Every category&apos;s eligibility rules and judging process, all in one place — no registration needed.
            When you know where you fit, head to the official portal to start your entry.
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <a href="https://visitengland-chapters.secure-platform.com/a/organizations/LEI/home" target="_blank" rel="noopener noreferrer"
              data-testid="criteria-page-portal-link"
              className="inline-flex items-center gap-2 bg-mustard text-charcoal px-5 py-3 rounded-full font-semibold hover:bg-base transition-colors">
              <PenLine size={16}/> Start an application <ExternalLink size={14}/>
            </a>
            <Link to="/awards" data-testid="criteria-page-back"
              className="inline-flex items-center gap-2 border border-base/30 text-base px-5 py-3 rounded-full font-semibold hover:border-base transition-colors">
              <ArrowLeft size={16}/> Back to the awards
            </Link>
          </div>
        </div>
      </section>
      <section className="py-12 md:py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <CriteriaAccordion />
        </div>
      </section>
    </div>
  );
}
